import React from 'react'
import styled from 'styled-components'
import Carousel from './carousel'
import { Grid } from 'antd';
import MainBanner from './mainBanner';

const TopBanner = () => {
    const { useBreakpoint } = Grid;
    const breakpoints = useBreakpoint();

    const Banner = styled.div`
        height: ${((breakpoints.xs || breakpoints.sm) && !breakpoints.lg) ? '313px' : '730px'};
    `
    return (
        <div className='top-home-banner'>
            <div className="relative">
                <Banner>
                    <MainBanner />
                    <div className="div-carousel">
                        <Carousel />
                    </div>
                </Banner>
            </div>
        </div >
    )
}

export default TopBanner